export default function usePathname() {
  return global.__AT_STORE__.pathname;
}
